import React, { useEffect, useState } from 'react';
import { VehiculosAdapter } from '../../../../../infraestructure/persistence/rest/VehiculosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { SelectorVehiculosMultiple  as SelectorVehiculos}  from './selector';
import {createOptions} from './functions';

export const SelectorVehiculosContainer = (props: any) => {
  
	let { selectedOptions, onChange } = props;
	const api = new VehiculosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [vehiculos, setVehiculos] = useState<any>([])
	let [selOptions, setSelOptions] = useState<any>(selectedOptions);
	let result: any;
  
  useEffect(()=>{
	onChange && onChange([]);
    getVehiculos();
  },[]);

  	useEffect(()=>{
		setSelOptions(selectedOptions);
	  }, [selectedOptions])

	const getVehiculos = async () => {
		try {
			result = await api.ListarVehiculos();
			if(result.data && result.data!=="")
			{
				setVehiculos([ ...result.data ] || []);
				setSelOptions(createOptions([ ...result.data ] || []));
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorVehiculos {...{...props,...{selectedOptions:selOptions}}} options={vehiculos}/>
};

export default SelectorVehiculosContainer;